var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingVsAudited(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1595_16326)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1595_16326)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1595_16326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3999 0.400391H9.5999C4.51888 0.400391 0.399902 4.51937 0.399902 9.60039V70.4004C0.399902 75.4814 4.51888 79.6004 9.5999 79.6004H70.3999C75.4809 79.6004 79.5999 75.4814 79.5999 70.4004V9.60039C79.5999 4.51937 75.4809 0.400391 70.3999 0.400391Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.267 16.6682H53.1093V14.0812H44.7003C44.6268 12.2093 43.0902 10.7129 41.2001 10.7129C39.3101 10.7129 37.7735 12.2093 37.7 14.0812H29.0136V16.6682H22.8553C21.6726 16.6682 20.7134 17.6274 20.7134 18.8102V67.8589C20.7134 69.0416 21.6721 70.0009 22.8553 70.0009H59.267C60.4498 70.0009 61.409 69.0416 61.409 67.8589V18.8097C61.409 17.6269 60.4503 16.6682 59.267 16.6682ZM39.4234 13.9395C39.5395 13.1798 40.1605 12.5593 40.9198 12.4431C42.1388 12.2564 43.1735 13.2911 42.9867 14.5101C42.8706 15.2693 42.2496 15.8903 41.4903 16.0065C40.2718 16.1933 39.2366 15.1585 39.4234 13.9395Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5532 68.2872H21.142C19.9592 68.2872 19 67.3285 19 66.1453V17.097C19 15.9143 19.9587 14.9551 21.142 14.9551H57.5537C58.7364 14.9551 59.6956 15.9138 59.6956 17.097V66.1453C59.6951 67.3285 58.7364 68.2872 57.5532 68.2872Z",
    fill: "#E35E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2628 61.2339L23.7496 60.9319C23.383 60.9285 23.0889 60.6285 23.0923 60.2619L23.4781 20.0069C23.4815 19.6403 23.7815 19.3462 24.1481 19.3496L55.6613 19.6516C56.0279 19.655 56.322 19.955 56.3185 20.3216L55.9328 60.5766C55.9289 60.9432 55.6289 61.2378 55.2628 61.2339Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7996 59.9657L24.2888 60.4794C23.9227 60.4852 23.6208 60.1931 23.6144 59.827L22.9581 19.5754C22.9522 19.2088 23.2443 18.9073 23.6105 18.901L55.1212 18.3868C55.4873 18.3809 55.7893 18.6731 55.7956 19.0397L56.4519 59.2912C56.4583 59.6579 56.1662 59.9598 55.7996 59.9657Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0343 59.7971H23.5191C23.1525 59.7971 22.8555 59.5001 22.8555 59.1335V18.8766C22.8555 18.5099 23.1525 18.2129 23.5191 18.2129H55.0338C55.4004 18.2129 55.6974 18.5099 55.6974 18.8766V59.1335C55.6974 59.5001 55.4004 59.7971 55.0343 59.7971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.987 12.3683C42.9135 10.4959 41.3769 9 39.4869 9C37.5969 9 36.0602 10.4964 35.9867 12.3683H27.2998V20.4004H51.3955V12.3683H42.987ZM39.7766 14.2936C38.5576 14.4804 37.5228 13.4457 37.7096 12.2267C37.8258 11.4674 38.4468 10.8464 39.206 10.7302C40.425 10.5435 41.4597 11.5782 41.273 12.7972C41.1568 13.5564 40.5363 14.1775 39.7766 14.2936Z",
    fill: "#75566E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3955 17.4004H27.2998V20.3991H51.3955V17.4004Z",
    fill: "#8F6986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7025 36.7497H44.0694C43.6308 36.7497 43.2754 36.3943 43.2754 35.9556V23.4078C43.2754 22.9691 43.6308 22.6133 44.0694 22.6133H51.7025C52.1412 22.6133 52.4971 22.9691 52.4971 23.4078V35.9556C52.4971 36.3943 52.1412 36.7497 51.7025 36.7497Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9768 35.9029H44.9186C44.4799 35.9029 44.1245 35.5475 44.1245 35.1088V24.2628C44.1245 23.8241 44.4799 23.4688 44.9186 23.4688H50.9768C51.4155 23.4688 51.7708 23.8241 51.7708 24.2628V35.1088C51.7708 35.5475 51.415 35.9029 50.9768 35.9029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 24.3262H40.3119",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 26.8945H40.3119",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 29.4668H40.3119",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 32.0352H40.3119",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 34.6074H40.3119",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 37.1777H40.3119",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3119 39.7461H25.105H51.7711",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3119 42.3184H25.105H51.7711",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3119 44.8867H25.105H51.7711",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3119 47.459H25.105H51.7711",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3119 50.0273H25.105H51.7711",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3119 52.5996H25.105H51.7711",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3119 55.168H25.105H51.7711",
    stroke: "#BFBFBF",
    strokeWidth: 1.7479,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1595_16326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1595_16326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1595_16326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingVsAudited);
export default __webpack_public_path__ + "static/media/BookingVsAudited.dcd09a1f06ecf546b936a636982a9941.svg";
export { ForwardRef as ReactComponent };